import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/common/components/ui/skeleton';
import { TableBody, TableCell, TableRow } from '@/common/components/ui/table';

interface PolicyListSkeletonProps {
  rowCount: number;
}

export const PolicyListSkeleton = ({ rowCount }: PolicyListSkeletonProps) => {
  const { t } = useTranslation();

  return (
    <TableBody
      className="flex-1 overflow-auto min-h-0"
      aria-label={t('policy.loadingPolicies')}
    >
      {Array.from({ length: rowCount }).map((_, index) => (
        <TableRow key={`skeleton-${rowCount}-${index}`}>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-32 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-40 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-24 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-28 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-24 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-32 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-24 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="h-14">
            <Skeleton className="h-4 w-20 bg-muted-foreground/20" />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
